<form class="fl-none" [formGroup]="form">
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-6">
      <label class="label" data-test-id="effective-from-label">Effective From</label>
      <div>
        <p-date-picker
          dateFormat="mm/dd/yy"
          formControlName="effectiveFromDate"
          styleClass="form-control"
          [readonlyInput]="true"
          [maxDate]="form.get('effectiveToDate').value"
          appendTo="body"
          [showOnFocus]="false"
          [showIcon]="true"
          data-test-id="effective-from-calendar"
          ></p-date-picker>
      </div>
    </div>
    <div class="col-span-6">
      <label class="label" data-test-id="effective-to-label">Effective To</label>
      <div>
        <p-date-picker
          dateFormat="mm/dd/yy"
          formControlName="effectiveToDate"
          styleClass="form-control"
          [readonlyInput]="true"
          [minDate]="form.get('effectiveFromDate').value"
          appendTo="body"
          [showOnFocus]="false"
          [showIcon]="true"
          data-test-id="effective-to-calendar"
          ></p-date-picker>
      </div>
    </div>
  </div>
  <div class="flex justify-end gap-4 mt-4">
      <button
        pButton
        type="button"
        icon="pi pi-times"
        label="Cancel"
        severity="info"
        (click)="onCancel()"
        data-test-id="effective-date-cancel-button"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-plus"
        label="Update"
        [disabled]="form.invalid"
        (click)="onUpdate()"
        data-test-id="effective-date-update-button"
      ></button>
  </div>
</form>
